import { Route, Routes } from "react-router-dom";
import AssessmentCategoriesPage from "./AssessmentCategoriesPage";
import AssessmentCategoryPage from "./AssessmentCategoryPage";

const AssessmentSummaryPage = () => (
  <Routes>
    <Route>
      <Route index element={<AssessmentCategoriesPage />} />
      <Route path=":id" element={<AssessmentCategoryPage />} />
    </Route>
  </Routes>
);

export default AssessmentSummaryPage;
